import { createContext, useContext } from 'react';

export const DialogContext = createContext<any>(null);

export const useDialog = () => {
  return useContext(DialogContext);
};
